import { render, staticRenderFns } from "./OnboardingRoot.vue?vue&type=template&id=d2a63dd8&scoped=true&"
import script from "./OnboardingRoot.vue?vue&type=script&lang=js&"
export * from "./OnboardingRoot.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingRoot.vue?vue&type=style&index=0&id=d2a63dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a63dd8",
  null
  
)

export default component.exports